<template>
   <div class=""
    style="
        padding-top: 20px;
        background-color: #f3f3f3;
        padding: 20px 20px 10px 20px;

        margin-top: 20px;
        border-radius: 3px;

        height: 100%;
    ">
       <div style="font-family: 'Raleway', Arial, Helvetica, sans-serif;">
           <v-row>
               <h3 style="width:100%;" class="grey pa-2 text-uppercase">PODCAST</h3>
                <v-col cols="12">
                    <template v-for="(a,i) in honor">
                        <div  :key="i" style="padding:40px 0px!important; border-bottom:1px solid black;">
                            <v-row>
                                <v-col col="12">
                                    <div id="audio" class="player-wrapper">
                                        <div style="position:relative; let:0; margin-right:40px"> EPISODIO {{ a.episodio }}</div>
                                        <player
                                            :file="require('../assets/podcast/'+a.url+'.mp3')"></player>
                                    </div>
                                </v-col>
                                <v-col cols="8">
                                     <h2 > {{ a.nombre }}  </h2>
                                      <p>{{ a.bio }} </p>
                                </v-col>
                                <v-col cols="4" v-if="a.foto">
                                     <img
                                        :src="require('../assets/img/miembros/'+ a.foto)"
                                        style="min-width:80px; width:14vw; max-height:140px; max-width:200px;"
                                    />
                                </v-col>
                            </v-row>



                             <template v-for="(ar,o) in a.textos">
                                <p :key="o">{{ ar }} </p>
                            </template>
                        </div>
                    </template>
                </v-col>
           </v-row>
       </div>
   </div>
</template>

<script>
import player from '@/components/player';
export default {
    components:{
        player
    },
    data: () => ({
        honor:[
            {
                episodio: "10",
                url:"Podcast_Ep_Munoz",
                foto:"fotogracielamunoz.jpg",
                nombre:"Graciela Muñoz Farida. [labsonoro.cl]",
                pais:"CHILE",
                bio:"Compositora, violinista e investigadora",
                textos:[
                    "Sus obras han sido presentadas en Chile, Latinoamérica y Europa en cada una de ellas la composición se orienta desde la experimentación concebida como una pregunta a partir de la cual ingresar en pliegues y procesos, poéticos y lúdicos, que intentan transitar marginales a una normalizada musicalidad. Trabajó en los estudios de música electroacústica de Fundación Phonos, Barcelona, con Andrés Lewin-Richter. Es Magíster en Artes Mediales por la Universidad de Chile, su proceso de grado consistió en una instalación donde convergieron la complementariedad de dos flujos en riesgo: el paisaje sonoro del río Baker en el lecho seco del río Petorca. Es Doctora en Filosofía, mención en Estética y Teoría del Arte por la Universidad Chile."
                ]
            },
            {
                episodio: "9",
                url:"Podcast_Ep_Mika Martini",
                foto:"MikaMartini.jpg",
                nombre:"Mika Martini",
                pais:"CHILE",
                bio:"es el proyecto individual principal de Hugo Espinosa Chellew (Chile, 1967)",
                textos:[
                    "Músico electrónico autodidacta y director del sello discográfico independiente Pueblo Nuevo Netlabel.",
                    "Con estudios en arquitectura y titulado en Diseño, Espinosa ha desarrollado sus capacidades artísticas en ámbitos que van desde la dirección de videoclips, la animación 3-D, el diseño gráfico tradicional, multimedia y, a partir del año 2001, diseño para Web.",
                    "Bajo este alias, Espinosa da inicio a un trabajo musical solista a principios del año 2004, con el firme objetivo de rescatar y mezclar sonidos provenientes del bagaje étnico chileno con elementos abstractos, vinculados a las técnicas del “microsampling” y la corriente “minimal”, desarrollando un trabajo paralelo más ligado a la música experimental y a la improvisación electrónica."
                ]
            },
            {
                episodio: "8",
                url:"Podcast_Ep_Aguilera",
                foto:"fotovaleaguilera.jpeg",
                nombre:"Valentina Aguilera Muñoz ",
                pais:"CHILE",
                bio:"Licenciada en artes, con mención en Teoría de la música de la Universidad de Chile.",
                textos:[
                    "Artista Sonora y Compositora de música experimental electrónica, para medios audiovisuales y escénicos. Co-creadora del Colectivo Residencial desde el año 2017, quienes realizan el concierto de música electrónica Porno Espectral y el proyecto de archivo sonoro Memoria Sonora. Ha participado en diversos espacios: Festival Sur Aural (Bolivia), Concierto electroacústico SIMUC en Hamburgo (Alemania), Radio Tëctónica, Pueblo Nuevo (Santiago, Chile), Concierto de música electroacústica Universidad Austral (Valdivia, Chile)."
                ]
            },
            {
                episodio: "7",
                url:"Podcast_Ep_Gabriel_Morales",
                foto:"",
                nombre:"Gabriel Morales",
                pais:"CHILE",
                bio:"",
                textos:[
                ]
            },
            {
                episodio: "6",
                url:"Podcast_Ep_Besoain",
                foto:"besoain.jpg",
                nombre:"Javiera Besoaín",
                pais:"CHILE",
                bio:"Licenciada en educación y profesora general básica con mención en educación matemática, compositora y artista visual autodidacta.",
                textos:[
                ]
            },
            {
                episodio: "5",
                url:"Podcast_Ep_Claudio Merlet",
                foto:"merlet1.jpg",
                nombre:"Claudio Merlet",
                pais:"CHILE",
                bio:"Compositor y Lutier Experimental",
                textos:[
                    " Compositor y Lutier Experimental, que incluyendo diversas tendencias concebidas desde las nuevas tecnologías, integra los campos de la ciencia, el arte y la tradición para ejecutarla en una nueva concepción de la expresión sonora. Su trabajo musical ha formado parte de diversas producciones, especialmente por lo realizado en teatro, televisión, danza y cine. Además ha participado de distintas residencias internacionales y ha dado conciertos, charlas y montado exhibiciones en diversos festivales y encuentros internacionales de prestigio, destacando In-Sonora (ES), Radical db (ES), EviMus (DE), Festival Internacional de Música Experimental (BR), Rumor Arte Sonora (BR), Entre Lugares Sonoros (BR), Sonoteca (PE), International Computer Music Conference (ICMA), Festival Sur Aural (BO), Festival Internacional de Música Contemporánea Darwin Vargas (CL), Ai-Maako (CL), Voltajes Aleatorios (CL), Pow Wow (CL), entre otros. Su trabajo está mayormente orientado a la composición contemporánea en entornos de síntesis modular, programación, instalaciones sonoras y a la utilización de instrumentos experimentales de su propia autoría.",
                ]
            },
            {
                episodio: "4",
                url:"Podcast_Ep_Ajizu",
                foto:"ajizufoto.png",
                nombre:"Áji Zu (Amawta Relmu)",
                pais:"CHILE",
                bio:"Artista Sonora residente en Buenos Aires",
                textos:[
                    "Nace en Santiago de Chile en donde realiza estudios musicales en el conservatorio de la Universidad de Chile, se titula de Ingeniería en Sonido en ARCOS, es Diplomada en Arte Sonoro en la Universidad de Chile, actualmente es becaria Chile Crea FONDART cursando la Maestría en Tecnología y Estética de las Artes Electrónicas en UNTREF, Buenos Aires, Argentina.",
                ]
            },
            {
                episodio: "3",
                url:"Podcast_Ep_Seiten_Wall",
                foto:"ep3.png",
                nombre:"Seiten Wall",
                pais:"CHILE",
                bio:"Músico y compositor (Instituto Profesional Arcos).",
                textos:[
                    "Integrante de las agrupaciones experimentales “GMS/FBW” (con Gerardo Figueroa y Martín Benavides, entre otros), ION (con Phronima) y “Una Banda” (con varios artistas desconocidos y no tanto)",
                    "Integrante desde el 2016 de la Comunidad Electroacústica de Chile (CECh).",
                    "Desde 2012, tiene a su cargo el netlabel Amakonda Amus y reparte su actividad entre diversos proyectos musicales, una tienda de discos virtual, su hijo y el ocio de la vida.",

                ]
            },
            {
                episodio: "2",
                url:"Podcast_Ep_Cani",
                foto:"20.png",
                nombre:"Georgina Canifrú ",
                pais:"CHILE",
                bio:"Artista sonora y Gestora de información.",
                textos:[
                    "Se interesa en la composición de piezas y miniaturas basadas en paisajes sonoros y grabaciones que realiza desde el año 2012. Ha participado en Encuentros, festivales, talleres, residencias e instancias de poesía, performance, arte sonoro, música electroacústica, ruido y composición para radio en Argentina, Perú, Brasil y Chile, destacando Weaving Music for radio by Latin american women composers, proyecto de música y radio arte que fue patrocinado por la UNESCO (2018), Festival PM – Poesía y Música, New Music Festival Lüneburg, Alemania, como parte de los conciertos de SIMUC – Sociedad Internacional de Música chilena y en instancias de radio arte como Radio Tsonami o 60 seconds radio.",
                    "Es Diplomada en Arte sonoro, Universidad de Chile, Magíster en artes / mención artes visuales, Pontificia Universidad Católica de Chile PUC, Bibliotecaria documentalista y Licenciada en Gestión de información, Universidad Tecnológica Metropolitana UTEM.",
                    "Fue becaria del Taller de Creación poética de la Fundación Pablo Neruda (2000). Publica Vacío animal [Poesía] (2009).",

                ]
            },
            {
                episodio: "1",
                url:"Podcast_Ep_1",
                foto:"9.jpg",
                nombre:"Marcelo Espíndola ",
                pais:"CHILE",
                bio:"Percusionista titulado en el Instituto de Música de Universidad Católica de Chile, en el año 2015 obtiene su grado de Magister en Artes.",
                textos:[
                    "Como percusionista ha participado en diversas agrupaciones musicales, pasando desde la orquesta clásica, la música contemporánea y música popular. Desde 1996 hasta hoy, integra la banda de música soul, Matahari, con los cuales ha editado tres discos: “Deja el cuerpo” premio Altazor 2003, “Matahari acústico” y “No Pares”.",
                    "Integró el Grupo de Percusión de la Universidad Católica entre los años 1991-2006., donde participó en la edición de los disco “Música chilena para percusión” volumen I y II, como intérprete, compositor y productor.",
                    "Desde el año 2004, participa en la Comunidad Electroacústica de Chile, CECH, con quienes realiza y produce el Festival Internacional de Música Electroacústica Ai-maako.",
                    "Ha compuesto la música para diversas agrupaciones de música popular o docta, obras de teatro y cine. Su música se ha interpretado tanto en Chile como en el extranjero. En el año 2001 y 2003 es premiado en el concurso “Música de este lado del sur”, organizado por al SCD, con las canciones “Despierto en un silencio” y “Volando el cielo”, editadas por el sello azul.",
                    "En la actualidad su labor como docente, entre otras, se desarrolla en el Instituto de Música de la Universidad Católica de Chile y en la Universidad Metropolitana de Ciencias de la Educación, UMCE"
                ]
            },


        ],
        miembros:[
             {

                nombre:"JOSÉ ROJAS NAVEA",
                pais:"CHILE",
                bio:"Jose Rojas Navea es músico e investigador independiente, licenciado en Teoría de la Musica de la Universidad de Chile y con estudios en Musicología de la misma casa de estudios.  Como investigador coordina la web y publicación digital KURICHE.cl dedicada a la cultura de raíz afro en Chile y es también co-áutor del libro Danza Afro en Chile: abriendo caminos (FONDART 2019). Como percusionista en Chile ha sido parte de ZAHIR, de la orquesta de musica del barroco americano Capilla de Indias, del trio Yanoseusa, y de la banda En Tu Contra, en el Reino Unido ha colaborado con la agrupación Quimantú, y es parte de Red Trio.  En su trabajo para danza afro, fue director musical de la Compañía de Danza y Música LOGUNEDÉ  y la Compañía MESTIZO. Es en su trabajo para danza contemporánea en donde mas ha podido desarrollar la practica de música electrónica y electroacustica tanto como músico acompañante en clases de danza, como tambien componiendo para coreografias y performances específicas junto a los coreografes Rodrigo Chaverini, Paula Montecinos, Francisca Espinoza, Macarena Campbell, Camilo Rossel y Albertina Pisano (UK/Italia) . Junto a la coreógrafa Andrea Torres crea el espacio para la creación escénica TorresRojas CuerpoCreativo que han realizado un total de 7 obras y colaboraciones. En Chile ha presentado sus trabajos electro en las versiones 2012 y 2020 del festival Ai Maako y en el Encuentro de Prácticas Sonoras FRICCIONES (2013), junto a los músicos Gerardo Figueroa y Raul Diaz forman la Orquesta Arribista presentándose en distintas instancias sonoras durante el año 2012. Como músico electrónico y electroacustico solista, ha tocado en las ciudades de Edimburgo (Escocia), Sheffield y Londres junto a músicos chilenos y británicos. El año 2020 edita bajo Pueblo Nuevo Netlabel su primer disco Fuera de Lugar y participa con su pieza auDIYovisual AL Golpe co-creado junto a Andrea Torres en el festival Santo Noise (Cordoba-Argentina) Actualmente imparte cursos de percusión en EL TALLER (Edimburgo), es tutor en el proyecto Musicians In Exile (Glasgow), toca percusiónes en la agrupación de música nordestina Bristol Branch y es el compositor de la compañía CASI con base en Montpellier (Francia) dirigida por Gabriel Ávila. "
            },

        ]
    })
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Podcast.vue